import React, { useEffect } from "react";
import "./Experience.css";
import ImageComponent from "../components/ImageComponent";
import Card from "../components/Card";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

function Experience() {
  const { ref, inView } = useInView();
  const animation = useAnimation();
  const animationHead = useAnimation();
  const animateQuote = useAnimation();

  useEffect(() => {
    if (inView) {
      animation.start({
        x: 0,
        transition: { type: "spring", duration: 2, bounce: 0.3, staggerChildren: 0.1, delayChildren: 0.3 },
      });

      animationHead.start({
        x: 0,
        transition: { type: "spring", duration: 1, bounce: 0.3 },
      });

      animateQuote.start({
        opacity: 1,
        transition: { delay: 1},
        transitionTimingFunction: 'ease-in-out'
        
      })
    } else if (!inView) {
      animation.start({
        x: "-100vw",
      });
      animationHead.start({
        x: 9999,
      });

      animateQuote.start({
        opacity: 0,
      })
    }
  }, [animateQuote, animation, animationHead, inView]);
  return (
    <div  id="experience" className="experience">
      <div ref={ref} className="exp__wrapper">
        <motion.div animate={animationHead} className="experience__header">
          <hr className="hr__line1" />
          <h2>Experience</h2>
          <hr className="hr__line2" />
        </motion.div>
        <motion.div animate={animateQuote} className="exp__quote">
          <h3>
            <span>“</span>The only way to do great work , <br />
            is to love what you do<span>”</span>
          </h3>
        </motion.div>
        <motion.div animate={animation} className="image__container">
          <motion.div className="imageRow">
            <Card>
              <ImageComponent
                exptitle="HTML5"
                techImage={require("../image/html5.png")}
              />
            </Card>
            <Card>
              <ImageComponent
                exptitle="JAVASCRIPT"
                techImage={require("../image/javascript.png")}
              />
            </Card>
            <Card>
              <ImageComponent
                exptitle="MONGO DB"
                techImage={require("../image/mongo.png")}
              />
            </Card>
          </motion.div>
          <motion.div className="imageRow">
            <Card>
              <ImageComponent
                exptitle="REACT"
                techImage={require("../image/react.png")}
              />
            </Card>
            <Card>
              <ImageComponent
                exptitle="NODE JS"
                techImage={require("../image/nodejs.png")}
              />
            </Card>
            <Card>
              <ImageComponent
                exptitle="REACT NATIVE"
                techImage={require("../image/reactNative.png")}
              />
            </Card>
          </motion.div>
          <motion.div className="imageRow">
            <Card>
              <ImageComponent
                exptitle="MY SQL"
                techImage={require("../image/msql.png")}
              />
            </Card>
            <Card className="card__detail">
              <div className="alignCard__detail">
                <h5>My Experience</h5>
                <p className="cardDetail__text">
                  These are the few tech, I have soiled my hands with these past
                  years. They are quite powerful and reliable to create a full
                  fledged application. My language of choice is javascript and I
                  have 3 years of coding experience in javascript. And I am still learning
                  lot of new things too. As always, exploring new technologies
                  or libraries never cease to amuse me. If you have projects
                  to discuss, <a href="#contact">Let's Go</a>
                </p>
              </div>
            </Card>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}

export default Experience;
